"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStore = void 0;
var getSingletonStore_1 = require("./getSingletonStore");
var WebSiteStore = (function () {
    function WebSiteStore() {
    }
    WebSiteStore.prototype.init = function (config) {
        this.config = config;
    };
    WebSiteStore.prototype.getParams = function (key) {
        if (!this.hasInfo()) {
            return null;
        }
        return this.config[key];
    };
    WebSiteStore.prototype.replaceUrl = function (url) {
        if (!this.hasInfo() || typeof this.config.replaceUrl !== "function") {
            return url;
        }
        return this.config.replaceUrl(url);
    };
    WebSiteStore.prototype.hasInfo = function () {
        return !!this.config;
    };
    return WebSiteStore;
}());
exports.getStore = getSingletonStore_1.default(WebSiteStore);
